import { motion } from 'framer-motion';
import { Shield, Clock, Award, Wrench, Truck } from 'lucide-react';

const features = [
  {
    icon: Clock,
    title: 'Hızlı Servis',
    description: 'Çoğu onarım aynı gün içinde tamamlanır',
  },
  {
    icon: Award,
    title: 'Uzman Ekip',
    description: 'Sertifikalı teknisyenler tarafından servis',
  },
  {
    icon: Wrench,
    title: 'Orijinal Parça',
    description: 'Sadece orijinal ve kaliteli yedek parçalar',
  },
  {
    icon: Truck,
    title: 'Ücretsiz Kargo',
    description: 'Türkiye geneli ücretsiz kargo hizmeti',
  },
  {
    icon: Shield,
    title: 'Güvenilir Hizmet',
    description: 'Yılların deneyimi ile profesyonel destek',
  },
];

export const FeaturesSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-sm font-medium text-primary uppercase tracking-wider mb-3"
          >
            Neden Biz?
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-foreground mb-4"
          >
            TeslaPro Farkı
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
          >
            Müşteri memnuniyetini ön planda tutarak, kaliteli ve güvenilir hizmet sunuyoruz.
          </motion.p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-start gap-4"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold font-display text-foreground mb-1">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
